import { useState } from 'react';
import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger,
} from '@/components/ui/sheet';

export default function AgentNotificationsBell() {
  const [open, setOpen] = useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 relative text-primary-foreground/70 hover:text-primary-foreground hover:bg-primary-foreground/10"
        >
          <Bell className="h-4 w-4" />
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-80 sm:w-96">
        <SheetHeader>
          <SheetTitle className="text-base">Notifications</SheetTitle>
        </SheetHeader>
        <div className="mt-4 text-center py-12 text-muted-foreground text-sm">
          <Bell className="h-8 w-8 mx-auto mb-3 opacity-40" />
          <p>No new notifications</p>
        </div>
      </SheetContent>
    </Sheet>
  );
}
